<p-dialog
  #eventWizardModal
  modal="true"
  [(visible)]="showModal"
  [closable]="false"
  styleClass="atlas-dialog-xl"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '65vh' }"
>
  <ng-template #header>
    <div class="wizard-dialog-header">
      <h3>{{ event.EventName }}</h3>
      <div class="wizard-dialog-header-sub" [hidden]="_loadingEventForRegistration">
        <div>
          {{ event?.StartDate | date: 'fullDate' }}<span *ngIf="event?.StartTime">, {{ event?.StartTime }}</span>
          <span *ngIf="(event?.StartDate | date: 'yMd') != (event?.EndDate | date: 'yMd')"
            >- {{ event?.EndDate | date: 'fullDate' }}<span *ngIf="event?.EndTime">, {{ event?.EndTime }}</span></span
          >
          <span
            *ngIf="
              (event?.StartDate | date: 'yMd') == (event?.EndDate | date: 'yMd') && event?.EndTime && event?.StartTime != event?.EndTime
            "
            >- {{ event?.EndTime }}</span
          >
        </div>
        <div>{{ 'events.registration.wizard.title' | translate | titlecase }}</div>
      </div>
    </div>
  </ng-template>
  <div *ngIf="_loadingEventForRegistration || _loadingRegistration">
    <wl-busy show="true"></wl-busy> {{ 'common.loading' | translate | ucfirst }}
  </div>
  <form #registrationForm [hidden]="_loadingEventForRegistration || _loadingRegistration">
    <wlx-tabs #registrationWizardTabsComponent>
      <wlx-tab title="{{ 'events.registration.wizard.contact.title' | translate | titlecase }}" #registrationWizardContactTab>
        <wl-event-v4-registration-wizard-contact
          #registrationWizardContactComponent
          (onRegistrationProfileChanged)="registrationProfileChanged($event)"
        ></wl-event-v4-registration-wizard-contact>
      </wlx-tab>
      <wlx-tab title="{{ 'events.registration.wizard.items.title' | translate | titlecase }}" #registrationWizardItemsTab>
        <div *ngIf="!registrationWizardPaymentInfoComponent.initialLoadComplete">
          <wl-busy show="true"></wl-busy> {{ 'common.loading' | translate | ucfirst }}
        </div>
        <div [hidden]="!registrationWizardPaymentInfoComponent.initialLoadComplete">
          <wl-event-v4-registration-wizard-items
            #registrationWizardItemsComponent
            (onRegistrationItemsChanged)="registrationItemsChanged()"
          ></wl-event-v4-registration-wizard-items>
        </div>
      </wlx-tab>
      <wlx-tab title="{{ 'events.registration.wizard.attendees.title' | translate | titlecase }}" #registrationWizardAttendeesTab>
        <div *ngIf="!registrationWizardPaymentInfoComponent.initialLoadComplete">
          <wl-busy show="true"></wl-busy> {{ 'common.loading' | translate | ucfirst }}
        </div>

        <div [hidden]="!registrationWizardPaymentInfoComponent.initialLoadComplete">
          <wl-event-v4-registration-wizard-attendees
            #registrationWizardAttendeesComponent
            [registrationProfile]="_registrationProfile"
          ></wl-event-v4-registration-wizard-attendees>
        </div>
      </wlx-tab>

      <wlx-tab [isTabWellContent]="true">
        <ng-template>
          <wl-event-v4-registration-wizard-attendee-tab-nav
            [attendees]="registration?.Attendees"
            [enableNewButton]="_attendeesLoaded && registrationWizardAttendeesComponent.canAddNewAttendee"
            (onAddAttendee)="handleAttendeeNavAddNewAttendeeClick()"
            (onAttendeeClick)="handleAttendeeNavAttendeeClick($event)"
          ></wl-event-v4-registration-wizard-attendee-tab-nav>
        </ng-template>
      </wlx-tab>
      <wlx-tab title="{{ 'events.registration.wizard.payment-info.title' | translate | titlecase }}" #registrationWizardPaymentTab>
        <div *ngIf="!registrationWizardPaymentInfoComponent.initialLoadComplete">
          <wl-busy show="true"></wl-busy> {{ 'common.loading' | translate | ucfirst }}
        </div>
        <div [hidden]="!registrationWizardPaymentInfoComponent.initialLoadComplete">
          <wl-event-v4-registration-wizard-payment-info
            #registrationWizardPaymentInfoComponent
          ></wl-event-v4-registration-wizard-payment-info>
        </div>
      </wlx-tab>
      <wlx-tab
        title="{{ 'events.registration.wizard.sponsor.title' | translate | titlecase }}"
        [enabled]="!registration.IsEdit && _sponsorTabEnabled"
        #registrationWizardSponsorTab
      >
        <wl-event-v4-registration-wizard-sponsor #registrationWizardSponsorComponent></wl-event-v4-registration-wizard-sponsor>
      </wlx-tab>
    </wlx-tabs>
  </form>

  <ng-template class="flex row-collapse space-between-center w-100" pTemplate="footer">
    <div class="w-50">
      <p-select
        class="mr-10"
        placeholder="{{ 'events.registration.wizard.select-profile-to-jump-to' | translate }}"
        [(ngModel)]="selectedJumpToProfileId"
        [options]="jumpToProfilesItems"
      ></p-select>
      <a target="_blank" [routerLink]="['/profile', selectedJumpToProfileId]">
        <button pButton type="button" class="atlas-btn atlas-btn-default tall" [disabled]="!selectedJumpToProfileId">
          {{ 'events.registration.wizard.open-profile' | translate | uppercase }}
        </button>
      </a>
    </div>
    <div class="w-50 flex row-collapse content-end">
      <div *ngIf="!validationResult.isValid && validationResult.errors.length > 0" class="alert alert-danger">
        {{ validationResult.error }}
        <ul [hidden]="!validationResult.errors">
          <li *ngFor="let error of validationResult.errors">
            {{ error }}
          </li>
        </ul>
      </div>
      <div [hidden]="_loadingEventForRegistration" class="mct-flex mct-row mct-justify-center mct-items-center mct-gap-10">
        <wl-busy [show]="isSaving"></wl-busy>
        <div class="flex row-collapse content-end gap-5px">
          <button
            pButton
            type="button"
            class="atlas-btn atlas-btn-secondary tall"
            icon="pi pi-cancel"
            [label]="'common.cancel' | translate | titlecase"
            [disabled]="isSaving"
            data-cy="btnRegistrationWizardSave"
            (click)="wizardCancel()"
          ></button>
          <button
            pButton
            type="button"
            class="atlas-btn atlas-btn-secondary tall"
            icon="pi pi-chevron-left"
            [label]="'common.back' | translate | titlecase"
            [disabled]="registrationWizardTabsComponent.isOnFirstTab"
            (click)="wizardBack()"
          ></button>
          <button
            pButton
            type="button"
            class="atlas-btn atlas-btn-secondary tall"
            icon="pi pi-chevron-right"
            iconPos="right"
            [label]="'common.next' | translate | titlecase"
            [disabled]="registrationWizardTabsComponent.isOnLastTab || (registrationWizardItemsTab.selected && !hasSelectedEventItems)"
            data-cy="btnRegistrationWizardNext"
            (click)="wizardNext()"
          ></button>
          <button
            pButton
            type="button"
            class="atlas-btn atlas-btn-primary tall"
            icon="pi pi-save"
            [label]="'common.save' | translate | titlecase"
            [disabled]="!hasSelectedEventItems || isSaving || _loadingEventForRegistration || !initialLoadComplete || !_attendeesLoaded"
            data-cy="btnRegistrationWizardSave"
            (click)="wizardSave()"
          ></button>
        </div>
      </div>
    </div>
  </ng-template>
</p-dialog>
